import React from "react";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { get, orderBy } from "lodash";
import useStyles from "./../styles";
import attachmentImg from "Assets/images/file-type/pdf.svg";

// import { useTranslation } from "react-i18next";
import { NOTIFICATION_LIST_DATE_TIME } from "src/constants";
import { getBrowserTime } from "src/utils/general";
import { useFormContext } from "react-hook-form";
import { Box } from "@material-ui/core";

const DisplayFieldList = () => {
  const classes = useStyles();
  const {
    register,
    watch,
    setValue,
    formState: { errors }
  } = useFormContext();
  const { termsandCondition, disabledView } = watch();
  const sortedTnC = orderBy(
    get(termsandCondition, "imprint", []),
    ["version"],
    ["desc"]
  );

  return (
    <Box className={classes.root}>
      {sortedTnC.map((res, index) => {
        return (
          <Box mt={2}>
            <Accordion key={index} className={classes.accordion}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel5a-content"
                id="panel5a-header"
                className={classes.accordionSummary}>
                <Typography className={classes.heading}>
                  V{get(res, "version") + 1} |{" "}
                  {getBrowserTime(
                    get(res, "createdAt", null),
                    NOTIFICATION_LIST_DATE_TIME
                  )}
                </Typography>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>
                <a href={get(res, "url", "")}>
                  <img
                    src={attachmentImg}
                    alt="images"
                    className={classes.termsAttachmentImg}
                    
                  />
                </a>
              </AccordionDetails>
            </Accordion>
          </Box>
        );
      })}
    </Box>
  );
};

export default DisplayFieldList;
